/**
 * Helps with initializing select form field according to provided data.
 *
 * Uses select2 plugin.
 *
 * Created by Jan Bradac on 10.6.2015.
 *
 * TODO: move to Forms namespace.
 *
 * @memberOf Lfl
 */
Lfl.SelectInitializer;

if (Lfl.Files.isLoadedFirstTime(Lfl, "SelectInitializer")) {
    (function (Lfl, $, undefined) {
        (function (SelectInitializer, $, undefined) {
            /**
             * Set of parameters that were used to initialize different selects.
             * @type {Object} initializationParameters
             */
            var initializationParameters = {};

            /*
             |-------------------------------------------------------------------------------------------------------------------
             | Public methods
             |-------------------------------------------------------------------------------------------------------------------
             */

            /**
             * Initializes a new select2 based on provided parameters.
             *
             * @param parameters
             * @param {string} parameters.elementId The HTML id of the select input element.
             * @param {string} parameters.placeholder Text that should be displayed when no value is selected but some
             * options are available. Note: "When placeholder is used for a non-multi-value select box, it requires that
             * you include an empty tag as your first option" - Select2 documentation.
             * @param {string} parameters.noValuesInfo Text that should be displayed above the select when no options are
             * present. For example, it is used after reloading the select via AJAX and receiving an empty possible options set.
             * @param {string} parameters.noValuesPlaceholder Text that should be displayed inside the select when no
             * options are present. Note the difference between no values *text*, which will be displayed above the select
             * and *placeholder* which will be displayed inside the select. Link: SelectFieldBuilder::NoValuesInfoVsPlaceholder
             * @param {bool} parameters.shouldClear Whether the select2 options should be empty and display a
             * "No options" message.
             * @param {bool} [parameters.initialValue] The initially selected value. Should only be used when data is
             * programmatically provided. In all cases you should also provide the selected value into the Form::select.
             * @param {Object} parameters.select2Parameters A set of parameters for the select2 plugin.
             * @memberOf Lfl.SelectInitializer
             */
            SelectInitializer.initSelect = function (parameters) {
                FunctionsCaller.register(function () {
                    var $selectElement = $('#' + parameters.elementId);
                    parameters = prepareParameters(parameters);
                    initializationParameters[parameters.elementId] = parameters;

                    $selectElement.show();
                    $selectElement.select2(parameters.select2Parameters);

                    if (parameters.shouldClear) {
                        $selectElement.val('').trigger('change');
                    } else if (typeof parameters.initialValue !== 'undefined') {
                        $selectElement.val(parameters.initialValue).trigger('change');
                    }
                });
            };

            /**
             * Changes available select options for select with given id.
             *
             * Note: due to technical constraints the whole select2 has to be reinitialized, which causes glitches, if
             * the select is visible, so it is recommended that this operation is performed behind a loading animation.
             *
             * Additional info: https://github.com/select2/select2/issues/2830
             *
             * @param id
             * @param {JSON} newSelectOptions
             * @memberOf Lfl.SelectInitializer
             */
            SelectInitializer.changeSelectOptions = function (id, newSelectOptions) {

                var $select = $('#' + id);

                $select.select2("destroy");

                $select.html(createSelectOptionsHtmlFromJson(newSelectOptions));

                var select2Parameters = initializationParameters[id].select2Parameters;

                var $noValuesInfoSection = getNoValuesInfoSection($select);

                if (newSelectOptions.length !== 0) {
                    $noValuesInfoSection.hide();

                    select2Parameters['placeholder'] = initializationParameters[id].placeholder;
                    select2Parameters['disabled'] = false;
                } else {
                    // No options are available so we disable and show the proper text

                    $noValuesInfoSection.show();
                    $noValuesInfoSection.html(initializationParameters[id].noValuesInfo);

                    select2Parameters['placeholder'] = initializationParameters[id].noValuesPlaceholder;
                    select2Parameters['disabled'] = true;
                }

                $select.select2(initializationParameters[id].select2Parameters);

            };

            /*
             |-------------------------------------------------------------------------------------------------------------------
             | Private methods
             |-------------------------------------------------------------------------------------------------------------------
             */

            function prepareParameters(parameters) {
                if (typeof parameters.select2Parameters === 'undefined') {
                    parameters.select2Parameters = {};
                }
                if (typeof parameters.select2Parameters.width === 'undefined') {
                    parameters.select2Parameters.width = '100%';
                }

                if (typeof parameters.select2Parameters.dropdownParent === 'undefined') {
                    parameters.select2Parameters.dropdownParent = $('#' + parameters.elementId).parent();
                }

                return parameters;
            }

            /**
             *
             * @param {JSON} selectOptions
             */
            function createSelectOptionsHtmlFromJson(selectOptions) {
                var html = "";
                _.each(selectOptions, function (item) {
                    var key = item.key;
                    var value = item.value;

                    if (value.constructor === Array) {
                        console.warning("Multidimensinal arrays as options are not properly supported yet. Beware of " +
                            "select limits which enable only one level of nesting via optgroup.");
                    }
                    html += "<option value=" + key + ">" + value + "</option>\n";
                });

                return html;
            }


            /**
             * Returns the section where no values text should be placed based on the select element.
             * @param {jQuery} $select
             * @return {jQuery}
             */
            function getNoValuesInfoSection($select) {
                return $($select.siblings("[data-lfl-select-section='no-values-info']")[0]);
            }
        }(Lfl.SelectInitializer = Lfl.SelectInitializer || {}, jQuery));
    }(window.Lfl = window.Lfl || {}, jQuery));
}

